import { render, staticRenderFns } from "./CancelBookingPopup.vue?vue&type=template&id=01165c2e&scoped=true&"
import script from "./CancelBookingPopup.vue?vue&type=script&lang=js&"
export * from "./CancelBookingPopup.vue?vue&type=script&lang=js&"
import style0 from "./CancelBookingPopup.vue?vue&type=style&index=0&id=01165c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01165c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01165c2e')) {
      api.createRecord('01165c2e', component.options)
    } else {
      api.reload('01165c2e', component.options)
    }
    module.hot.accept("./CancelBookingPopup.vue?vue&type=template&id=01165c2e&scoped=true&", function () {
      api.rerender('01165c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/CancelBookingPopup.vue"
export default component.exports